// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item {
  margin-bottom: 8px;
}

.ustas-text-overflow {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ustas-text-overflow:hover, .ustas-text-overflow:focus {
  text-overflow: clip;
  white-space: normal;
  word-break: break-all;
}

.input-container {
  display: flex;
  width: 100%;
  color: var(--text-color);
  flex-wrap: wrap;
}
.input-container_inline {
  flex-wrap: nowrap;
}
.input-container .label {
  width: 100%;
  margin-right: 8px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.input-container .label_inline {
  width: 192px;
  font-size: 12px;
}
.input-container .value {
  flex: 1;
  position: relative;
}
.input-container .value .error {
  bottom: 0;
  right: 0;
  left: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
